import ContactField from '../../fields/contactfield'
import NewField from '@admin/components/fields/new'
import Button from '@admin/components/button'
import Icon from '@admin/components/icon'
import T from '@admin/components/t'
import PropTypes from 'prop-types'
import React from 'react'

class Contact extends React.Component {

  static contextTypes = {
    form: PropTypes.object,
    locale: PropTypes.object
  }

  static propTypes = {
    config: PropTypes.object,
    fields: PropTypes.array,
    form: PropTypes.object,
    program: PropTypes.object
  }

  _handleAdd = this._handleAdd.bind(this)

  render() {
    const fields = this._getFields()
    const { program } = this.props
    return (
      <div className="flowchart-designer-blocks">
        <p><T text="t(These fields belong to the contact and will update the contact properties when the form is submitted)" /></p>
        { fields.map((field, index) => (
          <div className="flowchart-designer-block" key={`field_${index}`} { ...this._getField(field) }>
            <div className="flowchart-designer-block-icon action">
              <Icon svg={ field.svg } />
            </div>
            <div className="flowchart-designer-block-label">
              <T text={ field.label } /> (<T text={`t(${field.field.contactfield.type})`} />)
            </div>
          </div>
        )) }
        { program?.access_type === 'manage' &&
          <Button { ...this._getAdd() } />
        }
      </div>
    )
  }

  _getAdd() {
    return {
      label: 'Add Contact Property',
      className: 'link',
      handler: this._handleAdd
    }
  }

  _getFields() {
    const { config, fields } = this.props
    const used = config.fields.reduce((used, field) => [
      ...used,
      ...field.type === 'contactfield' ? [_.get(field, 'contactfield.name')] : []
    ], [])
    return fields.filter(field => {
      return !_.includes(used, field.field.contactfield.name)
    }).map(field => {
      const label = this.context.locale.t(field.label)
      return {
        label,
        svg: this._getIcon(field.field.contactfield.type),
        type: 'contactfield',
        field: {
          ...field.field.contactfield || {},
          ...field.field,
          label
        },
        component: ContactField
      }
    })
  }

  _getField(field) {
    return {
      draggable: true,
      onDragStart: this._handleDragStart.bind(this, field)
    }
  }

  _getIcon(type) {
    if(type === 'textfield') return 'case_sensitive'
    if(type === 'textarea') return 'case_sensitive'
    if(type === 'emailfield') return 'envmailelope'
    if(type === 'phonefield') return 'phone'
    if(type === 'addressfield') return 'map_pin'
    if(type === 'datefield') return 'calendar'
    if(type === 'checkbox') return 'square_check'
    if(type === 'checkboxgroup') return 'square_check'
    if(type === 'checkboxes') return 'square_check'
    if(type === 'radiogroup') return 'circle_dot'
    if(type === 'filefield') return 'cloud_upload'
    if(type === 'dropdown') return 'chevron_down'
    if(type === 'moneyfield') return 'dollar_sing'
    return 'user_round'
  }

  _handleAdd() {
    const { program } = this.props
    this.context.form.push(<NewField action={`/api/admin/crm_programs/${program.id}/fields`} />)
  }

  _handleDragStart(field, e) {
    e.stopPropagation()
    e.dataTransfer.dropEffect = 'all'
    e.dataTransfer.setData('field', JSON.stringify({
      ...field.field,
      type: 'contactfield'
    }))
  }

}

export default Contact
